// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3LJk1","title":"Info_title__Fjunz","links":"Info_links__3dYMK","link":"Info_link__G1i_M","logo":"Info_logo__1JpRu"};